omadapp.singletons.main = new(function() {
    var t = this;
    var $ = jQuery;
    var $b = $("body")
    var App = omadapp.App

    $b.on("omadapp.inicializado", initialize)
    $b.on("omadapp.prenavigation",checkNavigation)
    $b.on("omadapp.scene.prenavigation",checkSceneNavigation)
    var UTILS = omadapp.singletons.utils

    t.initialized = false

    var $appContext


    function initialize() {
    	App = omadapp.App
        createOriVars()
    	$appContext = App.getContext()

        $appContext.on("quizz-ended",quizEnded)
        var quiz = App.config.quizz
        if (quiz.images) {
            var $svg = App.getContext().find(".desktop-svg-header,.desktop-svg-footer")
           
           new SizeGetter(quiz.images.desktop,$svg,function(w,h,$svg ) {
               $svg.find(" image").each(function(i,o) {
                   var $image =  $(o)
                   $image.attr("href",quiz.images.desktop)
                   $image.attr("width",w+"px")
                   $image.attr("height",h+"px")

               })
           })

            var $svg = App.getContext().find(".mobile-svg-header,.mobile-svg-footer")
           
           new SizeGetter(quiz.images.mobile,$svg,function(w,h,$svg ) {
               $svg.find(" image").each(function(i,o) {
                   var $image =  $(o)
                   $image.attr("href",quiz.images.mobile)
                   $image.attr("width",w+"px")
                   $image.attr("height",h+"px")

               })
           })
            svgIdCorrection()
            $(window).resize(calculateSize)
            calculateSize()
        }

    }

    function SizeGetter(image_url,$svg,callback){
        var img = new Image();
        img.onload = function(){
            callback(img.naturalWidth,img.naturalHeight,$svg )
        };
        img.src = image_url;
    }

    function createOriVars() {
        App.getContext().find("svg").each(function(i,o) {
            var $o = $(o)
            $o.attr("oriW",( $o.attr("width")))
            $o.attr("oriH",( $o.attr("height")))

        })
    }
    function svgIdCorrection () {
        var $c = App.getContext()
        $c.find("svg [id*='mask-']").each(function(i,o) {
            var $o = $(o)
            var oldId = $o.attr("id")
            var newId = oldId+i
            $o.attr("id",newId)
            var $p = $o.parents("svg")
            $p.find("[mask*='"+oldId+"']").each(function(ii,oo) {
                $(oo).attr("mask","url(#"+newId+")")
            })


        })
    }

    function quizEnded(e,scores) {
        App.getPageController("end_game").preparePage(scores)
        App.navegar("end_game")
    }

    function checkSceneNavigation (e,incoming,outgoing) {
        $(document).scrollTop(0)
    }

    function checkNavigation (e,a,b) {
         App.getContext().attr("data-page",a)
        calculateSize()
        $(document).scrollTop(0)
        
    }
    function changeSize(selector) {
        App.getContext().find(selector).each(function(i,o) {
           var $svg =$(o)

           var ow = parseInt($svg.attr("oriW"))
           var oh = parseInt($svg.attr("oriH"))

           if (isNaN(ow)) {
            return
           }
           var cs = window.innerWidth/ow
           $svg.attr("width",ow*cs)
           $svg.attr("height",oh*cs)


        })
    }
    function calculateSize() {
        var quiz = App.config.quizz
        if (quiz.images) {
            changeSize(".desktop-svg-header")
            changeSize(".mobile-svg-header")
            changeSize(".desktop-svg-footer")
            changeSize(".mobile-svg-footer")
        }
    }
})
